import * as e from "react";
import { useState as j, useRef as z, useEffect as F, useMemo as Ne } from "react";
import { u as Le, a as he, b as ze, c as Fe, d as Ve, e as Be, f as ge, g as He, h as je, i as De, j as _e, k as Oe, l as ve, m as We, n as qe, o as $e, p as Ue, q as Ge, r as Qe, s as pe, t as Xe, v as Ye } from "./hooks-C7fu1g_i.mjs";
import { a as x, c as ee } from "./room-BC_ml4G1.mjs";
import { RoomEvent as Ze, ConnectionQuality as Y, Track as I, RemoteTrackPublication as $, RemoteAudioTrack as Je, ConnectionState as Z } from "livekit-client";
import { ae as te, af as Ee, w as Ke, u as et, f as tt, c as nt, ag as at, X as rt, Y as ct, a1 as U, l as D, ah as q, ai as lt, i as _, B as it, aj as we, j as ot, ak as st, m as ut, al as ne, p as ke, am as dt, an as mt, ao as ft, ap as ht, aq as gt, ar as vt, R as pt } from "./contexts-BtSGUJjc.mjs";
const cn = /* @__PURE__ */ e.forwardRef(
  function(n, a) {
    const { buttonProps: c } = Le(n);
    return /* @__PURE__ */ e.createElement("button", { ref: a, ...c }, n.children);
  }
), ln = /* @__PURE__ */ e.forwardRef(
  function({ room: n, ...a }, c) {
    const r = he(n);
    return /* @__PURE__ */ e.createElement("div", { ref: c, ...a }, r);
  }
), on = /* @__PURE__ */ e.forwardRef(
  function(n, a) {
    const { mergedProps: c } = ze({ props: n });
    return /* @__PURE__ */ e.createElement("button", { ref: a, ...c }, n.children);
  }
), sn = /* @__PURE__ */ e.forwardRef(
  function(n, a) {
    const { buttonProps: c } = Fe(n);
    return /* @__PURE__ */ e.createElement("button", { ref: a, ...c }, n.children);
  }
), Et = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M1.354.646a.5.5 0 1 0-.708.708l14 14a.5.5 0 0 0 .708-.708L11 10.293V4.5A1.5 1.5 0 0 0 9.5 3H3.707zM0 4.5a1.5 1.5 0 0 1 .943-1.393l9.532 9.533c-.262.224-.603.36-.975.36h-8A1.5 1.5 0 0 1 0 11.5z" }), /* @__PURE__ */ e.createElement("path", { d: "m15.2 3.6-2.8 2.1a1 1 0 0 0-.4.8v3a1 1 0 0 0 .4.8l2.8 2.1a.5.5 0 0 0 .8-.4V4a.5.5 0 0 0-.8-.4" })), wt = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M0 4.5A1.5 1.5 0 0 1 1.5 3h8A1.5 1.5 0 0 1 11 4.5v7A1.5 1.5 0 0 1 9.5 13h-8A1.5 1.5 0 0 1 0 11.5zM15.2 3.6l-2.8 2.1a1 1 0 0 0-.4.8v3a1 1 0 0 0 .4.8l2.8 2.1a.5.5 0 0 0 .8-.4V4a.5.5 0 0 0-.8-.4" })), un = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "#FFF",
    d: "M4.99 3.99a1 1 0 0 0-.697 1.717L10.586 12l-6.293 6.293a1 1 0 1 0 1.414 1.414L12 13.414l6.293 6.293a1 1 0 1 0 1.414-1.414L13.414 12l6.293-6.293a1 1 0 0 0-.727-1.717 1 1 0 0 0-.687.303L12 10.586 5.707 4.293a1 1 0 0 0-.717-.303"
  }
)), dn = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 18, fill: "none", ...t }, /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 2.75A2.75 2.75 0 0 1 2.75 0h10.5A2.75 2.75 0 0 1 16 2.75v13.594a.75.75 0 0 1-1.234.572l-3.691-3.12a1.25 1.25 0 0 0-.807-.296H2.75A2.75 2.75 0 0 1 0 10.75zM2.75 1.5c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25h7.518c.65 0 1.279.23 1.775.65l2.457 2.077V2.75c0-.69-.56-1.25-1.25-1.25z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 4.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  }
)), oe = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...t }, /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M5.293 2.293a1 1 0 0 1 1.414 0l4.823 4.823a1.25 1.25 0 0 1 0 1.768l-4.823 4.823a1 1 0 0 1-1.414-1.414L9.586 8 5.293 3.707a1 1 0 0 1 0-1.414",
    clipRule: "evenodd"
  }
)), kt = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...t }, /* @__PURE__ */ e.createElement("g", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5 }, /* @__PURE__ */ e.createElement("path", { d: "M10 1.75h4.25m0 0V6m0-4.25L9 7M6 14.25H1.75m0 0V10m0 4.25L7 9" }))), mn = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...t }, /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M8.961.894C8.875-.298 7.125-.298 7.04.894c-.066.912-1.246 1.228-1.76.472-.67-.99-2.186-.115-1.664.96.399.824-.465 1.688-1.288 1.289-1.076-.522-1.95.994-.961 1.665.756.513.44 1.693-.472 1.759-1.192.086-1.192 1.836 0 1.922.912.066 1.228 1.246.472 1.76-.99.67-.115 2.186.96 1.664.824-.399 1.688.465 1.289 1.288-.522 1.076.994 1.95 1.665.961.513-.756 1.693-.44 1.759.472.086 1.192 1.836 1.192 1.922 0 .066-.912 1.246-1.228 1.76-.472.67.99 2.186.115 1.664-.96-.399-.824.465-1.687 1.288-1.289 1.076.522 1.95-.994.961-1.665-.756-.513-.44-1.693.472-1.759 1.192-.086 1.192-1.836 0-1.922-.912-.066-1.228-1.246-.472-1.76.99-.67.115-2.186-.96-1.664-.824.399-1.687-.465-1.289-1.288.522-1.076-.994-1.95-1.665-.961-.513.756-1.693.44-1.759-.472M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10",
    clipRule: "evenodd"
  }
)), fn = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...t }, /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 2.75A2.75 2.75 0 0 1 4.75 0h6.5A2.75 2.75 0 0 1 14 2.75v10.5A2.75 2.75 0 0 1 11.25 16h-6.5A2.75 2.75 0 0 1 2 13.25v-.5a.75.75 0 0 1 1.5 0v.5c0 .69.56 1.25 1.25 1.25h6.5c.69 0 1.25-.56 1.25-1.25V2.75c0-.69-.56-1.25-1.25-1.25h-6.5c-.69 0-1.25.56-1.25 1.25v.5a.75.75 0 0 1-1.5 0z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.78 7.47a.75.75 0 0 1 0 1.06l-2.25 2.25a.75.75 0 1 1-1.06-1.06l.97-.97H1.75a.75.75 0 0 1 0-1.5h4.69l-.97-.97a.75.75 0 0 1 1.06-1.06z",
    clipRule: "evenodd"
  }
)), bt = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...t }, /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M4 6.104V4a4 4 0 1 1 8 0v2.104c1.154.326 2 1.387 2 2.646v4.5A2.75 2.75 0 0 1 11.25 16h-6.5A2.75 2.75 0 0 1 2 13.25v-4.5c0-1.259.846-2.32 2-2.646M5.5 4a2.5 2.5 0 0 1 5 0v2h-5z",
    clipRule: "evenodd"
  }
)), Rt = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M12.227 11.52a5.48 5.48 0 0 0 1.246-2.97.5.5 0 0 0-.995-.1 4.5 4.5 0 0 1-.962 2.359l-1.07-1.07C10.794 9.247 11 8.647 11 8V3a3 3 0 0 0-6 0v1.293L1.354.646a.5.5 0 1 0-.708.708l14 14a.5.5 0 0 0 .708-.708zM8 12.5c.683 0 1.33-.152 1.911-.425l.743.743c-.649.359-1.378.59-2.154.66V15h2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h2v-1.522a5.5 5.5 0 0 1-4.973-4.929.5.5 0 0 1 .995-.098A4.5 4.5 0 0 0 8 12.5" }), /* @__PURE__ */ e.createElement("path", { d: "M8.743 10.907 5 7.164V8a3 3 0 0 0 3.743 2.907" })), yt = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", ...t }, /* @__PURE__ */ e.createElement(
  "path",
  {
    fillRule: "evenodd",
    d: "M2.975 8.002a.5.5 0 0 1 .547.449 4.5 4.5 0 0 0 8.956 0 .5.5 0 1 1 .995.098A5.5 5.5 0 0 1 8.5 13.478V15h2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h2v-1.522a5.5 5.5 0 0 1-4.973-4.929.5.5 0 0 1 .448-.547",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ e.createElement("path", { d: "M5 3a3 3 0 1 1 6 0v5a3 3 0 0 1-6 0z" })), Mt = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentcolor", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M0 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm6-5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm6-6a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }), /* @__PURE__ */ e.createElement("path", { d: "M0 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm6-5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm6-6a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" })), St = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentcolor", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M0 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm6-5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }), /* @__PURE__ */ e.createElement("path", { d: "M0 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm6-5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }), /* @__PURE__ */ e.createElement("g", { opacity: 0.25 }, /* @__PURE__ */ e.createElement("path", { d: "M12 .5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }), /* @__PURE__ */ e.createElement("path", { d: "M12 .5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }))), Ct = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentcolor", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M0 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }), /* @__PURE__ */ e.createElement("path", { d: "M0 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }), /* @__PURE__ */ e.createElement("g", { opacity: 0.25 }, /* @__PURE__ */ e.createElement("path", { d: "M6 6.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }), /* @__PURE__ */ e.createElement("path", { d: "M6 6.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm6-6a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }), /* @__PURE__ */ e.createElement("path", { d: "M12 .5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }))), It = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", ...t }, /* @__PURE__ */ e.createElement("g", { opacity: 0.25 }, /* @__PURE__ */ e.createElement("path", { d: "M0 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm6-5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm6-6a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }), /* @__PURE__ */ e.createElement("path", { d: "M0 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm6-5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5zm6-6a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5z" }))), be = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 16, fill: "none", ...t }, /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 2.75A2.75 2.75 0 0 1 2.75 0h14.5A2.75 2.75 0 0 1 20 2.75v10.5A2.75 2.75 0 0 1 17.25 16H2.75A2.75 2.75 0 0 1 0 13.25zM2.75 1.5c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h14.5c.69 0 1.25-.56 1.25-1.25V2.75c0-.69-.56-1.25-1.25-1.25z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.47 4.22a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1-1.06 1.06l-.97-.97v4.69a.75.75 0 0 1-1.5 0V6.56l-.97.97a.75.75 0 0 1-1.06-1.06z",
    clipRule: "evenodd"
  }
)), xt = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 16, fill: "none", ...t }, /* @__PURE__ */ e.createElement("g", { fill: "currentColor" }, /* @__PURE__ */ e.createElement("path", { d: "M7.28 4.22a.75.75 0 0 0-1.06 1.06L8.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L10 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L11.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L10 6.94z" }), /* @__PURE__ */ e.createElement(
  "path",
  {
    fillRule: "evenodd",
    d: "M2.75 0A2.75 2.75 0 0 0 0 2.75v10.5A2.75 2.75 0 0 0 2.75 16h14.5A2.75 2.75 0 0 0 20 13.25V2.75A2.75 2.75 0 0 0 17.25 0zM1.5 2.75c0-.69.56-1.25 1.25-1.25h14.5c.69 0 1.25.56 1.25 1.25v10.5c0 .69-.56 1.25-1.25 1.25H2.75c-.69 0-1.25-.56-1.25-1.25z",
    clipRule: "evenodd"
  }
))), se = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...t }, /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 0a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0V.75A.75.75 0 0 1 8 0",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 12a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 8 12",
    clipRule: "evenodd",
    opacity: 0.7
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 1.072a.75.75 0 0 1 .274 1.024l-1.25 2.165a.75.75 0 0 1-1.299-.75l1.25-2.165A.75.75 0 0 1 12 1.072",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 11.464a.75.75 0 0 1 .274 1.025l-1.25 2.165a.75.75 0 0 1-1.299-.75l1.25-2.165A.75.75 0 0 1 6 11.464",
    clipRule: "evenodd",
    opacity: 0.6
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.928 4a.75.75 0 0 1-.274 1.025l-2.165 1.25a.75.75 0 1 1-.75-1.3l2.165-1.25A.75.75 0 0 1 14.928 4",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.536 10a.75.75 0 0 1-.275 1.024l-2.165 1.25a.75.75 0 0 1-.75-1.298l2.165-1.25A.75.75 0 0 1 4.536 10",
    clipRule: "evenodd",
    opacity: 0.5
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 8a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5A.75.75 0 0 1 16 8",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 8a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1 0-1.5h2.5A.75.75 0 0 1 4 8",
    clipRule: "evenodd",
    opacity: 0.4
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.928 12a.75.75 0 0 1-1.024.274l-2.165-1.25a.75.75 0 0 1 .75-1.299l2.165 1.25A.75.75 0 0 1 14.928 12",
    clipRule: "evenodd",
    opacity: 0.9
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.536 6a.75.75 0 0 1-1.025.275l-2.165-1.25a.75.75 0 1 1 .75-1.3l2.165 1.25A.75.75 0 0 1 4.536 6",
    clipRule: "evenodd",
    opacity: 0.3
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 14.928a.75.75 0 0 1-1.024-.274l-1.25-2.165a.75.75 0 0 1 1.298-.75l1.25 2.165A.75.75 0 0 1 12 14.928",
    clipRule: "evenodd",
    opacity: 0.8
  }
), /* @__PURE__ */ e.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 4.536a.75.75 0 0 1-1.024-.275l-1.25-2.165a.75.75 0 1 1 1.299-.75l1.25 2.165A.75.75 0 0 1 6 4.536",
    clipRule: "evenodd",
    opacity: 0.2
  }
)), Pt = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...t }, /* @__PURE__ */ e.createElement("g", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5 }, /* @__PURE__ */ e.createElement("path", { d: "M13.25 7H9m0 0V2.75M9 7l5.25-5.25M2.75 9H7m0 0v4.25M7 9l-5.25 5.25" }))), Tt = /* @__PURE__ */ e.forwardRef(
  function({ trackRef: n, ...a }, c) {
    const r = te(), { mergedProps: i, inFocus: s } = Ve({
      trackRef: n ?? r,
      props: a
    });
    return /* @__PURE__ */ e.createElement(Ee.Consumer, null, (l) => l !== void 0 && /* @__PURE__ */ e.createElement("button", { ref: c, ...i }, a.children ? a.children : s ? /* @__PURE__ */ e.createElement(Pt, null) : /* @__PURE__ */ e.createElement(kt, null)));
  }
), hn = /* @__PURE__ */ e.forwardRef(
  function({
    kind: n,
    initialSelection: a,
    onActiveDeviceChange: c,
    onDeviceListChange: r,
    onDeviceSelectError: i,
    exactMatch: s,
    track: l,
    requestPermissions: o,
    onError: u,
    ...d
  }, f) {
    const m = Ke(), E = e.useRef("default"), w = e.useCallback(
      (p) => {
        m && m.emit(Ze.MediaDevicesError, p), u?.(p);
      },
      [m, u]
    ), { devices: g, activeDeviceId: v, setActiveMediaDevice: y, className: M } = Be({
      kind: n,
      room: m,
      track: l,
      requestPermissions: o,
      onError: w
    });
    e.useEffect(() => {
      a !== void 0 && y(a);
    }, [y]), e.useEffect(() => {
      typeof r == "function" && r(g);
    }, [r, g]), e.useEffect(() => {
      v !== E.current && c?.(v), E.current = v;
    }, [v]);
    const P = async (p) => {
      try {
        await y(p, { exact: s ?? !0 });
      } catch (R) {
        if (R instanceof Error)
          i?.(R);
        else
          throw R;
      }
    }, S = e.useMemo(
      () => x(d, { className: M }, { className: "lk-list" }),
      [M, d]
    ), h = !!g.find((p) => p.label.toLowerCase().startsWith("default"));
    function b(p, R, A) {
      return p === R || !h && A === 0 && R === "default";
    }
    return /* @__PURE__ */ e.createElement("ul", { ref: f, ...S }, g.map((p, R) => /* @__PURE__ */ e.createElement(
      "li",
      {
        key: p.deviceId,
        id: p.deviceId,
        "data-lk-active": b(p.deviceId, v, R),
        "aria-selected": b(p.deviceId, v, R),
        role: "option"
      },
      /* @__PURE__ */ e.createElement("button", { className: "lk-button", onClick: () => P(p.deviceId) }, p.label)
    )));
  }
), gn = /* @__PURE__ */ e.forwardRef(
  function({ label: n = "Allow Audio", ...a }, c) {
    const r = et(a.room), { mergedProps: i } = ge({ room: r, props: a });
    return /* @__PURE__ */ e.createElement("button", { ref: c, ...i }, n);
  }
), vn = /* @__PURE__ */ e.forwardRef(
  function({ label: n, ...a }, c) {
    const r = tt(), { mergedProps: i, canPlayAudio: s } = ge({ room: r, props: a }), { mergedProps: l, canPlayVideo: o } = He({ room: r, props: i }), { style: u, ...d } = l;
    return u.display = s && o ? "none" : "block", /* @__PURE__ */ e.createElement("button", { ref: c, style: u, ...d }, n ?? `Start ${s ? "Video" : "Audio"}`);
  }
);
function Re(t, n) {
  switch (t) {
    case I.Source.Microphone:
      return n ? /* @__PURE__ */ e.createElement(yt, null) : /* @__PURE__ */ e.createElement(Rt, null);
    case I.Source.Camera:
      return n ? /* @__PURE__ */ e.createElement(wt, null) : /* @__PURE__ */ e.createElement(Et, null);
    case I.Source.ScreenShare:
      return n ? /* @__PURE__ */ e.createElement(xt, null) : /* @__PURE__ */ e.createElement(be, null);
    default:
      return;
  }
}
function At(t) {
  switch (t) {
    case Y.Excellent:
      return /* @__PURE__ */ e.createElement(Mt, null);
    case Y.Good:
      return /* @__PURE__ */ e.createElement(St, null);
    case Y.Poor:
      return /* @__PURE__ */ e.createElement(Ct, null);
    default:
      return /* @__PURE__ */ e.createElement(It, null);
  }
}
const pn = /* @__PURE__ */ e.forwardRef(function({ showIcon: n, ...a }, c) {
  const { buttonProps: r, enabled: i } = je(a), [s, l] = e.useState(!1);
  return e.useEffect(() => {
    l(!0);
  }, []), s && /* @__PURE__ */ e.createElement("button", { ref: c, ...r }, (n ?? !0) && Re(a.source, i), a.children);
}), ye = /* @__PURE__ */ e.forwardRef(function(n, a) {
  const { className: c, quality: r } = De(n), i = e.useMemo(() => ({ ...x(n, { className: c }), "data-lk-quality": r }), [r, n, c]);
  return /* @__PURE__ */ e.createElement("div", { ref: a, ...i }, n.children ?? At(r));
}), K = /* @__PURE__ */ e.forwardRef(
  function({ participant: n, ...a }, c) {
    const r = nt(n), { className: i, infoObserver: s } = e.useMemo(() => at(r), [r]), { identity: l, name: o } = _e(s, {
      name: r.name,
      identity: r.identity,
      metadata: r.metadata
    }), u = e.useMemo(() => x(a, { className: i, "data-lk-participant-name": o }), [a, i, o]);
    return /* @__PURE__ */ e.createElement("span", { ref: c, ...u }, o !== "" ? o : l, a.children);
  }
), Me = /* @__PURE__ */ e.forwardRef(
  function({ trackRef: n, show: a = "always", ...c }, r) {
    const { className: i, isMuted: s } = Oe(n), l = a === "always" || a === "muted" && s || a === "unmuted" && !s, o = e.useMemo(
      () => x(c, {
        className: i
      }),
      [i, c]
    );
    return l ? /* @__PURE__ */ e.createElement("div", { ref: r, ...o, "data-lk-muted": s }, c.children ?? Re(n.source, !s)) : null;
  }
), Nt = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M160 180C204.182 180 240 144.183 240 100C240 55.8172 204.182 20 160 20C115.817 20 79.9997 55.8172 79.9997 100C79.9997 144.183 115.817 180 160 180Z",
      fill: "white",
      fillOpacity: 0.25
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M97.6542 194.614C103.267 191.818 109.841 192.481 115.519 195.141C129.025 201.466 144.1 205 159.999 205C175.899 205 190.973 201.466 204.48 195.141C210.158 192.481 216.732 191.818 222.345 194.614C262.703 214.719 291.985 253.736 298.591 300.062C300.15 310.997 291.045 320 280 320H39.9997C28.954 320 19.8495 310.997 21.4087 300.062C28.014 253.736 57.2966 214.72 97.6542 194.614Z",
      fill: "white",
      fillOpacity: 0.25
    }
  )
);
function Se(t, n = {}) {
  const [a, c] = e.useState(rt(t)), [r, i] = e.useState(a?.isMuted), [s, l] = e.useState(a?.isSubscribed), [o, u] = e.useState(a?.track), [d, f] = e.useState("landscape"), m = e.useRef(), { className: E, trackObserver: w } = e.useMemo(() => ct(t), [
    t.participant.sid ?? t.participant.identity,
    t.source,
    U(t) && t.publication.trackSid
  ]);
  return e.useEffect(() => {
    const g = w.subscribe((v) => {
      D.debug("update track", v), c(v), i(v?.isMuted), l(v?.isSubscribed), u(v?.track);
    });
    return () => g?.unsubscribe();
  }, [w]), e.useEffect(() => (o && (m.current && o.detach(m.current), n.element?.current && !(t.participant.isLocal && o?.kind === "audio") && o.attach(n.element.current)), m.current = n.element?.current, () => {
    m.current && o?.detach(m.current);
  }), [o, n.element]), e.useEffect(() => {
    if (typeof a?.dimensions?.width == "number" && typeof a?.dimensions?.height == "number") {
      const g = a.dimensions.width > a.dimensions.height ? "landscape" : "portrait";
      f(g);
    }
  }, [a]), {
    publication: a,
    isMuted: r,
    isSubscribed: s,
    track: o,
    elementProps: x(n.props, {
      className: E,
      "data-lk-local-participant": t.participant.isLocal,
      "data-lk-source": a?.source,
      ...a?.kind === "video" && { "data-lk-orientation": d }
    })
  };
}
var J, ue;
function Lt() {
  if (ue) return J;
  ue = 1;
  var t = "Expected a function", n = NaN, a = "[object Symbol]", c = /^\s+|\s+$/g, r = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, s = /^0o[0-7]+$/i, l = parseInt, o = typeof q == "object" && q && q.Object === Object && q, u = typeof self == "object" && self && self.Object === Object && self, d = o || u || Function("return this")(), f = Object.prototype, m = f.toString, E = Math.max, w = Math.min, g = function() {
    return d.Date.now();
  };
  function v(h, b, p) {
    var R, A, O, L, C, N, V = 0, re = !1, B = !1, G = !0;
    if (typeof h != "function")
      throw new TypeError(t);
    b = S(b) || 0, y(p) && (re = !!p.leading, B = "maxWait" in p, O = B ? E(S(p.maxWait) || 0, b) : O, G = "trailing" in p ? !!p.trailing : G);
    function Q(k) {
      var T = R, H = A;
      return R = A = void 0, V = k, L = h.apply(H, T), L;
    }
    function xe(k) {
      return V = k, C = setTimeout(W, b), re ? Q(k) : L;
    }
    function Pe(k) {
      var T = k - N, H = k - V, ie = b - T;
      return B ? w(ie, O - H) : ie;
    }
    function ce(k) {
      var T = k - N, H = k - V;
      return N === void 0 || T >= b || T < 0 || B && H >= O;
    }
    function W() {
      var k = g();
      if (ce(k))
        return le(k);
      C = setTimeout(W, Pe(k));
    }
    function le(k) {
      return C = void 0, G && R ? Q(k) : (R = A = void 0, L);
    }
    function Te() {
      C !== void 0 && clearTimeout(C), V = 0, R = N = A = C = void 0;
    }
    function Ae() {
      return C === void 0 ? L : le(g());
    }
    function X() {
      var k = g(), T = ce(k);
      if (R = arguments, A = this, N = k, T) {
        if (C === void 0)
          return xe(N);
        if (B)
          return C = setTimeout(W, b), Q(N);
      }
      return C === void 0 && (C = setTimeout(W, b)), L;
    }
    return X.cancel = Te, X.flush = Ae, X;
  }
  function y(h) {
    var b = typeof h;
    return !!h && (b == "object" || b == "function");
  }
  function M(h) {
    return !!h && typeof h == "object";
  }
  function P(h) {
    return typeof h == "symbol" || M(h) && m.call(h) == a;
  }
  function S(h) {
    if (typeof h == "number")
      return h;
    if (P(h))
      return n;
    if (y(h)) {
      var b = typeof h.valueOf == "function" ? h.valueOf() : h;
      h = y(b) ? b + "" : b;
    }
    if (typeof h != "string")
      return h === 0 ? h : +h;
    h = h.replace(c, "");
    var p = i.test(h);
    return p || s.test(h) ? l(h.slice(2), p ? 2 : 8) : r.test(h) ? n : +h;
  }
  return J = v, J;
}
var zt = Lt();
const de = /* @__PURE__ */ lt(zt);
function Ft(t) {
  const n = z(t);
  n.current = t, F(
    () => () => {
      n.current();
    },
    []
  );
}
function Vt(t, n = 500, a) {
  const c = z();
  Ft(() => {
    c.current && c.current.cancel();
  });
  const r = Ne(() => {
    const i = de(t, n, a), s = (...l) => i(...l);
    return s.cancel = () => {
      i.cancel();
    }, s.isPending = () => !!c.current, s.flush = () => i.flush(), s;
  }, [t, n, a]);
  return F(() => {
    c.current = de(t, n, a);
  }, [t, n, a]), r;
}
function Bt(t, n, a) {
  const c = ((u, d) => u === d), r = t instanceof Function ? t() : t, [i, s] = j(r), l = z(r), o = Vt(
    s,
    n,
    a
  );
  return c(l.current, r) || (o(r), l.current = r), [i, o];
}
function Ht({
  threshold: t = 0,
  root: n = null,
  rootMargin: a = "0%",
  freezeOnceVisible: c = !1,
  initialIsIntersecting: r = !1,
  onChange: i
} = {}) {
  var s;
  const [l, o] = j(null), [u, d] = j(() => ({
    isIntersecting: r,
    entry: void 0
  })), f = z();
  f.current = i;
  const m = ((s = u.entry) == null ? void 0 : s.isIntersecting) && c;
  F(() => {
    if (!l || !("IntersectionObserver" in window) || m)
      return;
    const g = new IntersectionObserver(
      (v) => {
        const y = Array.isArray(g.thresholds) ? g.thresholds : [g.thresholds];
        v.forEach((M) => {
          const P = M.isIntersecting && y.some((S) => M.intersectionRatio >= S);
          d({ isIntersecting: P, entry: M }), f.current && f.current(P, M);
        });
      },
      { threshold: t, root: n, rootMargin: a }
    );
    return g.observe(l), () => {
      g.disconnect();
    };
  }, [
    l,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(t),
    n,
    a,
    m,
    c
  ]);
  const E = z(null);
  F(() => {
    var g;
    !l && ((g = u.entry) != null && g.target) && !c && !m && E.current !== u.entry.target && (E.current = u.entry.target, d({ isIntersecting: r, entry: void 0 }));
  }, [l, u.entry, c, m, r]);
  const w = [
    o,
    !!u.isIntersecting,
    u.entry
  ];
  return w.ref = w[0], w.isIntersecting = w[1], w.entry = w[2], w;
}
const jt = /* @__PURE__ */ e.forwardRef(
  function({
    onTrackClick: n,
    onClick: a,
    onSubscriptionStatusChanged: c,
    trackRef: r,
    manageSubscription: i,
    ...s
  }, l) {
    const o = _(r), u = e.useRef(null);
    e.useImperativeHandle(l, () => u.current);
    const { ref: d, entry: f } = Ht({
      root: null
    }), [m] = Bt(f, 3e3), E = e.useRef(null), w = e.useRef(!1);
    e.useEffect(() => {
      w.current = !!i, E.current = o.publication instanceof $ ? o.publication : null;
    }, [o.publication, i]), e.useEffect(() => {
      i && o.publication instanceof $ && m?.isIntersecting === !1 && f?.isIntersecting === !1 && o.publication.setSubscribed(!1);
    }, [m, f, o, i]), e.useEffect(() => {
      i && o.publication instanceof $ && f?.isIntersecting === !0 && o.publication.setSubscribed(!0);
    }, [f, o, i]), e.useEffect(() => () => {
      w.current && E.current?.setSubscribed(!1);
    }, []);
    const {
      elementProps: g,
      publication: v,
      isSubscribed: y
    } = Se(o, {
      element: u,
      props: s
    });
    e.useEffect(() => {
      c?.(!!y);
    }, [y, c]);
    const M = (S) => {
      a?.(S), n?.({ participant: o?.participant, track: v });
    }, P = e.useCallback(
      (S) => {
        u.current = S, d(S);
      },
      [d]
    );
    return /* @__PURE__ */ e.createElement("video", { ref: P, ...g, muted: !0, onClick: M });
  }
), ae = /* @__PURE__ */ e.forwardRef(
  function({ trackRef: n, onSubscriptionStatusChanged: a, volume: c, ...r }, i) {
    const s = _(n), l = e.useRef(null);
    e.useImperativeHandle(i, () => l.current);
    const {
      elementProps: o,
      isSubscribed: u,
      track: d,
      publication: f
    } = Se(s, {
      element: l,
      props: r
    });
    return e.useEffect(() => {
      a?.(!!u);
    }, [u, a]), e.useEffect(() => {
      d === void 0 || c === void 0 || (d instanceof Je ? d.setVolume(c) : D.warn("Volume can only be set on remote audio tracks."));
    }, [c, d]), e.useEffect(() => {
      f === void 0 || r.muted === void 0 || (f instanceof $ ? f.setEnabled(!r.muted) : D.warn("Can only call setEnabled on remote track publications."));
    }, [r.muted, f, d]), /* @__PURE__ */ e.createElement("audio", { ref: l, ...o });
  }
);
function Dt(t) {
  const n = !!it();
  return t.participant && !n ? /* @__PURE__ */ e.createElement(we.Provider, { value: t.participant }, t.children) : /* @__PURE__ */ e.createElement(e.Fragment, null, t.children);
}
function _t(t) {
  const n = !!te();
  return t.trackRef && !n ? /* @__PURE__ */ e.createElement(ne.Provider, { value: t.trackRef }, t.children) : /* @__PURE__ */ e.createElement(e.Fragment, null, t.children);
}
const Ot = /* @__PURE__ */ e.forwardRef(
  function({
    trackRef: n,
    children: a,
    onParticipantClick: c,
    disableSpeakingIndicator: r,
    ...i
  }, s) {
    const l = _(n), { elementProps: o } = ve({
      htmlProps: i,
      disableSpeakingIndicator: r,
      onParticipantClick: c,
      trackRef: l
    }), u = We(l.participant), d = ot(), f = st()?.autoSubscription, m = e.useCallback(
      (E) => {
        l.source && !E && d && d.pin.dispatch && ut(l, d.pin.state) && d.pin.dispatch({ msg: "clear_pin" });
      },
      [l, d]
    );
    return /* @__PURE__ */ e.createElement("div", { ref: s, style: { position: "relative" }, ...o }, /* @__PURE__ */ e.createElement(_t, { trackRef: l }, /* @__PURE__ */ e.createElement(Dt, { participant: l.participant }, a ?? /* @__PURE__ */ e.createElement(e.Fragment, null, U(l) && (l.publication?.kind === "video" || l.source === I.Source.Camera || l.source === I.Source.ScreenShare) ? /* @__PURE__ */ e.createElement(
      jt,
      {
        trackRef: l,
        onSubscriptionStatusChanged: m,
        manageSubscription: f
      }
    ) : U(l) && /* @__PURE__ */ e.createElement(
      ae,
      {
        trackRef: l,
        onSubscriptionStatusChanged: m
      }
    ), /* @__PURE__ */ e.createElement("div", { className: "lk-participant-placeholder" }, /* @__PURE__ */ e.createElement(Nt, null)), /* @__PURE__ */ e.createElement("div", { className: "lk-participant-metadata" }, /* @__PURE__ */ e.createElement("div", { className: "lk-participant-metadata-item" }, l.source === I.Source.Camera ? /* @__PURE__ */ e.createElement(e.Fragment, null, u && /* @__PURE__ */ e.createElement(bt, { style: { marginRight: "0.25rem" } }), /* @__PURE__ */ e.createElement(
      Me,
      {
        trackRef: {
          participant: l.participant,
          source: I.Source.Microphone
        },
        show: "muted"
      }
    ), /* @__PURE__ */ e.createElement(K, null)) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(be, { style: { marginRight: "0.25rem" } }), /* @__PURE__ */ e.createElement(K, null, "'s screen"))), /* @__PURE__ */ e.createElement(ye, { className: "lk-participant-metadata-item" }))), /* @__PURE__ */ e.createElement(Tt, { trackRef: l }))));
  }
);
function En(t) {
  const n = x(t, { className: "lk-focus-layout" });
  return /* @__PURE__ */ e.createElement("div", { ...n }, t.children);
}
function wn({ trackRef: t, ...n }) {
  return /* @__PURE__ */ e.createElement(Ot, { trackRef: t, ...n });
}
function Ce({ tracks: t, ...n }) {
  return /* @__PURE__ */ e.createElement(e.Fragment, null, t.map((a) => /* @__PURE__ */ e.createElement(
    ne.Provider,
    {
      value: a,
      key: ke(a)
    },
    ee(n.children)
  )));
}
function Wt({
  totalPageCount: t,
  nextPage: n,
  prevPage: a,
  currentPage: c,
  pagesContainer: r
}) {
  const [i, s] = e.useState(!1);
  return e.useEffect(() => {
    let l;
    return r && (l = dt(r.current, 2e3).subscribe(
      s
    )), () => {
      l && l.unsubscribe();
    };
  }, [r]), /* @__PURE__ */ e.createElement("div", { className: "lk-pagination-control", "data-lk-user-interaction": i }, /* @__PURE__ */ e.createElement("button", { className: "lk-button", onClick: a }, /* @__PURE__ */ e.createElement(oe, null)), /* @__PURE__ */ e.createElement("span", { className: "lk-pagination-count" }, `${c} of ${t}`), /* @__PURE__ */ e.createElement("button", { className: "lk-button", onClick: n }, /* @__PURE__ */ e.createElement(oe, null)));
}
const qt = /* @__PURE__ */ e.forwardRef(
  function({ totalPageCount: n, currentPage: a }, c) {
    const r = new Array(n).fill("").map((i, s) => s + 1 === a ? /* @__PURE__ */ e.createElement("span", { "data-lk-active": !0, key: s }) : /* @__PURE__ */ e.createElement("span", { key: s }));
    return /* @__PURE__ */ e.createElement("div", { ref: c, className: "lk-pagination-indicator" }, r);
  }
);
function kn({ tracks: t, ...n }) {
  const a = e.createRef(), c = e.useMemo(
    () => x(n, { className: "lk-grid-layout" }),
    [n]
  ), { layout: r } = qe(a, t.length), i = $e(r.maxTiles, t);
  return Ue(a, {
    onLeftSwipe: i.nextPage,
    onRightSwipe: i.prevPage
  }), /* @__PURE__ */ e.createElement("div", { ref: a, "data-lk-pagination": i.totalPageCount > 1, ...c }, /* @__PURE__ */ e.createElement(Ce, { tracks: i.tracks }, n.children), t.length > r.maxTiles && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    qt,
    {
      totalPageCount: i.totalPageCount,
      currentPage: i.currentPage
    }
  ), /* @__PURE__ */ e.createElement(Wt, { pagesContainer: a, ...i })));
}
const $t = 130, Ut = 140, me = 1, Ie = 16 / 10, Gt = (1 - Ie) * -1;
function bn({ tracks: t, orientation: n, ...a }) {
  const c = e.useRef(null), [r, i] = e.useState(0), { width: s, height: l } = Ge(c), o = n || (l >= s ? "vertical" : "horizontal"), u = o === "vertical" ? Math.max(s * Gt, $t) : Math.max(l * Ie, Ut), d = mt(), f = Math.max(o === "vertical" ? (l - d) / u : (s - d) / u, me);
  let m = Math.round(f);
  Math.abs(f - r) < 0.5 ? m = Math.round(r) : r !== f && i(f);
  const E = Qe(t, m);
  return e.useLayoutEffect(() => {
    c.current && (c.current.dataset.lkOrientation = o, c.current.style.setProperty("--lk-max-visible-tiles", m.toString()));
  }, [m, o]), /* @__PURE__ */ e.createElement("aside", { key: o, className: "lk-carousel", ref: c, ...a }, /* @__PURE__ */ e.createElement(Ce, { tracks: E }, a.children));
}
function Rn({
  value: t,
  onPinChange: n,
  onWidgetChange: a,
  children: c
}) {
  const r = ft(t);
  return e.useEffect(() => {
    D.debug("PinState Updated", { state: r.pin.state }), n && r.pin.state && n(r.pin.state);
  }, [r.pin.state, n]), e.useEffect(() => {
    D.debug("Widget Updated", { widgetState: r.widget.state }), a && r.widget.state && a(r.widget.state);
  }, [a, r.widget.state]), /* @__PURE__ */ e.createElement(Ee.Provider, { value: r }, c);
}
const yn = /* @__PURE__ */ e.forwardRef(
  function({ trackRef: n, ...a }, c) {
    const d = _(n), f = pe(d, { bands: 7, loPass: 300 });
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        ref: c,
        width: "100%",
        height: "100%",
        viewBox: "0 0 200 90",
        ...a,
        className: "lk-audio-visualizer"
      },
      /* @__PURE__ */ e.createElement("rect", { x: "0", y: "0", width: "100%", height: "100%" }),
      /* @__PURE__ */ e.createElement(
        "g",
        {
          style: {
            transform: `translate(${130 / 2}px, 0)`
          }
        },
        f.map((m, E) => /* @__PURE__ */ e.createElement(
          "rect",
          {
            key: E,
            x: E * 10,
            y: 90 / 2 - m * 50 / 2,
            width: 6,
            height: m * 50
          }
        ))
      )
    );
  }
);
function Mn({ participants: t, ...n }) {
  return /* @__PURE__ */ e.createElement(e.Fragment, null, t.map((a) => /* @__PURE__ */ e.createElement(we.Provider, { value: a, key: a.identity }, ee(n.children))));
}
function Sn({ room: t, volume: n, muted: a }) {
  const c = Xe(
    [I.Source.Microphone, I.Source.ScreenShareAudio, I.Source.Unknown],
    {
      updateOnlyOn: [],
      onlySubscribed: !0,
      room: t
    }
  ).filter((r) => !r.participant.isLocal && r.publication.kind === I.Kind.Audio);
  return /* @__PURE__ */ e.createElement("div", { style: { display: "none" } }, c.map((r) => /* @__PURE__ */ e.createElement(
    ae,
    {
      key: ke(r),
      trackRef: r,
      volume: n,
      muted: a
    }
  )));
}
const Cn = /* @__PURE__ */ e.forwardRef(function({ childrenPosition: n = "before", children: a, ...c }, r) {
  const { name: i } = Ye();
  return /* @__PURE__ */ e.createElement("span", { ref: r, ...c }, n === "before" && a, i, n === "after" && a);
});
function Qt(t) {
  const n = e.useMemo(() => x(t, { className: "lk-toast" }), [t]);
  return /* @__PURE__ */ e.createElement("div", { ...n }, t.children);
}
const Xt = (t) => {
  const n = [];
  for (let a = 0; a < t; a++)
    n.push([a, t - 1 - a]);
  return n;
}, fe = (t) => [[Math.floor(t / 2)], [-1]], Yt = (t, n, a) => {
  const [c, r] = j(0), [i, s] = j([[]]);
  F(() => {
    if (t === "thinking")
      s(fe(n));
    else if (t === "connecting" || t === "initializing") {
      const o = [...Xt(n)];
      s(o);
    } else s(t === "listening" ? fe(n) : t === void 0 || t === "speaking" ? [new Array(n).fill(0).map((o, u) => u)] : [[]]);
    r(0);
  }, [t, n]);
  const l = z(null);
  return F(() => {
    let o = performance.now();
    const u = (d) => {
      d - o >= a && (r((m) => m + 1), o = d), l.current = requestAnimationFrame(u);
    };
    return l.current = requestAnimationFrame(u), () => {
      l.current !== null && cancelAnimationFrame(l.current);
    };
  }, [a, n, t, i.length]), i[c % i.length];
}, Zt = /* @__PURE__ */ new Map([
  ["connecting", 2e3],
  ["initializing", 2e3],
  ["listening", 500],
  ["thinking", 150]
]), Jt = (t, n) => {
  if (t === void 0)
    return 1e3;
  let a = Zt.get(t);
  return a && t === "connecting" && (a /= n), a;
}, Kt = /* @__PURE__ */ e.forwardRef(
  function({ state: n, options: a, barCount: c = 15, trackRef: r, track: i, children: s, ...l }, o) {
    const u = x(l, { className: "lk-audio-bar-visualizer" });
    let d = te();
    (r || i) && (d = r || i);
    const f = pe(d, {
      bands: c,
      loPass: 100,
      hiPass: 200
    }), m = a?.minHeight ?? 20, E = a?.maxHeight ?? 100, w = Yt(
      n,
      c,
      Jt(n, c) ?? 100
    );
    return /* @__PURE__ */ e.createElement("div", { ref: o, ...u, "data-lk-va-state": n }, f.map(
      (g, v) => s ? ee(s, {
        "data-lk-highlighted": w.includes(v),
        "data-lk-bar-index": v,
        className: "lk-audio-bar",
        style: { height: `${Math.min(E, Math.max(m, g * 100 + 5))}%` }
      }) : /* @__PURE__ */ e.createElement(
        "span",
        {
          key: v,
          "data-lk-highlighted": w.includes(v),
          "data-lk-bar-index": v,
          className: `lk-audio-bar ${w.includes(v) && "lk-highlighted"}`,
          style: {
            // TODO transform animations would be more performant, however the border-radius gets distorted when using scale transforms. a 9-slice approach (or 3 in this case) could work
            // transform: `scale(1, ${Math.min(maxHeight, Math.max(minHeight, volume))}`,
            height: `${Math.min(E, Math.max(m, g * 100 + 5))}%`
          }
        }
      )
    ));
  }
), In = /* @__PURE__ */ e.forwardRef(
  function({
    children: n,
    disableSpeakingIndicator: a,
    onParticipantClick: c,
    trackRef: r,
    ...i
  }, s) {
    const l = _(r), { elementProps: o } = ve({
      trackRef: l,
      htmlProps: i,
      disableSpeakingIndicator: a,
      onParticipantClick: c
    });
    return /* @__PURE__ */ e.createElement("div", { ref: s, style: { position: "relative", minHeight: "160px" }, ...o }, /* @__PURE__ */ e.createElement(ne.Provider, { value: l }, n ?? /* @__PURE__ */ e.createElement(e.Fragment, null, U(l) && /* @__PURE__ */ e.createElement(ae, { trackRef: l }), /* @__PURE__ */ e.createElement(Kt, { barCount: 7, options: { minHeight: 8 } }), /* @__PURE__ */ e.createElement("div", { className: "lk-participant-metadata" }, /* @__PURE__ */ e.createElement("div", { className: "lk-participant-metadata-item" }, /* @__PURE__ */ e.createElement(Me, { trackRef: l }), /* @__PURE__ */ e.createElement(K, null)), /* @__PURE__ */ e.createElement(ye, { className: "lk-participant-metadata-item" })))));
  }
);
function xn(t) {
  const [n, a] = e.useState(void 0), c = he(t.room);
  return e.useEffect(() => {
    switch (c) {
      case Z.Reconnecting:
        a(
          /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(se, { className: "lk-spinner" }), " Reconnecting")
        );
        break;
      case Z.Connecting:
        a(
          /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(se, { className: "lk-spinner" }), " Connecting")
        );
        break;
      case Z.Disconnected:
        a(/* @__PURE__ */ e.createElement(e.Fragment, null, "Disconnected"));
        break;
      default:
        a(void 0);
        break;
    }
  }, [c]), n ? /* @__PURE__ */ e.createElement(Qt, { className: "lk-toast-connection-state" }, n) : /* @__PURE__ */ e.createElement(e.Fragment, null);
}
const Pn = /* @__PURE__ */ e.forwardRef(
  function({ entry: n, hideName: a = !1, hideTimestamp: c = !1, messageFormatter: r, ...i }, s) {
    const l = e.useMemo(() => r ? r(n.message) : n.message, [n.message, r]), o = !!n.editTimestamp, u = new Date(n.timestamp), d = typeof navigator < "u" ? navigator.language : "en-US", f = n.from?.name ?? n.from?.identity;
    return /* @__PURE__ */ e.createElement(
      "li",
      {
        ref: s,
        className: "lk-chat-entry",
        title: u.toLocaleTimeString(d, { timeStyle: "full" }),
        "data-lk-message-origin": n.from?.isLocal ? "local" : "remote",
        ...i
      },
      (!c || !a || o) && /* @__PURE__ */ e.createElement("span", { className: "lk-meta-data" }, !a && /* @__PURE__ */ e.createElement("strong", { className: "lk-participant-name" }, f), (!c || o) && /* @__PURE__ */ e.createElement("span", { className: "lk-timestamp" }, o && "edited ", u.toLocaleTimeString(d, { timeStyle: "short" }))),
      /* @__PURE__ */ e.createElement("span", { className: "lk-message-body" }, l),
      /* @__PURE__ */ e.createElement("span", { className: "lk-message-attachements" }, n.attachedFiles?.map(
        (m) => m.type.startsWith("image/") && /* @__PURE__ */ e.createElement(
          "img",
          {
            style: { maxWidth: "300px", maxHeight: "300px" },
            key: m.name,
            src: URL.createObjectURL(m),
            alt: m.name
          }
        )
      ))
    );
  }
);
function Tn(t) {
  return ht(t, gt()).map((n, a) => {
    if (typeof n == "string")
      return n;
    {
      const c = n.content.toString(), r = n.type === "url" ? /^http(s?):\/\//.test(c) ? c : `https://${c}` : `mailto:${c}`;
      return /* @__PURE__ */ e.createElement("a", { className: "lk-chat-link", key: a, href: r, target: "_blank", rel: "noreferrer" }, c);
    }
  });
}
function An(t) {
  return /* @__PURE__ */ e.createElement(vt.Provider, { value: t.session }, /* @__PURE__ */ e.createElement(pt.Provider, { value: t.session.room }, t.children));
}
export {
  Tn as $,
  ae as A,
  Kt as B,
  on as C,
  sn as D,
  Mt as E,
  En as F,
  kn as G,
  St as H,
  Ct as I,
  It as J,
  Cn as K,
  Rn as L,
  hn as M,
  be as N,
  xt as O,
  Ot as P,
  An as Q,
  Sn as R,
  un as S,
  pn as T,
  se as U,
  gn as V,
  Qt as W,
  Me as X,
  _t as Y,
  Pt as Z,
  jt as _,
  Pn as a,
  Nt as b,
  dn as c,
  mn as d,
  fn as e,
  vn as f,
  bn as g,
  wn as h,
  xn as i,
  Ce as j,
  In as k,
  yn as l,
  Et as m,
  wt as n,
  oe as o,
  cn as p,
  ye as q,
  ln as r,
  Tt as s,
  kt as t,
  bt as u,
  Rt as v,
  yt as w,
  Dt as x,
  Mn as y,
  K as z
};
//# sourceMappingURL=components-zhA5OhZT.mjs.map
